/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_section_1_applies = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This policy applies to all information collected through our website, mobile applications, and any related services, sales, marketing, or events.`)
};

const es_privacy_section_1_applies = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta política aplica a toda la información recopilada a través de nuestro sitio web, aplicaciones móviles y cualquier servicio, venta, marketing o evento relacionado.`)
};

const de_privacy_section_1_applies = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Richtlinie gilt für alle Informationen, die über unsere Website, mobile Anwendungen und alle damit verbundenen Dienste, Verkaufs-, Marketing- oder Veranstaltungsaktivitäten erfasst werden.`)
};

const nl_privacy_section_1_applies = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit beleid is van toepassing op alle informatie die wordt verzameld via onze website, mobiele applicaties en alle gerelateerde diensten, verkoop, marketing of evenementen.`)
};

const fr_privacy_section_1_applies = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette politique s’applique à toutes les informations collectées via notre site web, nos applications mobiles et tous les services, ventes, marketing ou événements associés.`)
};

const it_privacy_section_1_applies = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa informativa si applica a tutte le informazioni raccolte tramite il nostro sito web, applicazioni mobili e tutti i servizi, vendite, marketing o eventi correlati.`)
};

const pt_br2_privacy_section_1_applies = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta política se aplica a todas as informações coletadas através do nosso site, aplicativos móveis e quaisquer serviços, vendas, marketing ou eventos relacionados.`)
};

const pt_privacy_section_1_applies = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta política aplica-se a toda a informação recolhida através do nosso website, aplicações móveis e quaisquer serviços, vendas, marketing ou eventos relacionados.`)
};

const ja_privacy_section_1_applies = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このポリシーは、当ウェブサイト、モバイルアプリケーション、およびすべての関連サービス、販売、マーケティング、イベントを通じて収集されるすべての情報に適用されます。`)
};

const zh_privacy_section_1_applies = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本政策适用于通过我们的网站、移动应用程序及任何相关服务、销售、营销或活动收集的所有信息。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_section_1_applies = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_section_1_applies(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_section_1_applies", locale)
	if (locale === "en") return en_privacy_section_1_applies(inputs)
	if (locale === "es") return es_privacy_section_1_applies(inputs)
	if (locale === "de") return de_privacy_section_1_applies(inputs)
	if (locale === "nl") return nl_privacy_section_1_applies(inputs)
	if (locale === "fr") return fr_privacy_section_1_applies(inputs)
	if (locale === "it") return it_privacy_section_1_applies(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_section_1_applies(inputs)
	if (locale === "pt") return pt_privacy_section_1_applies(inputs)
	if (locale === "ja") return ja_privacy_section_1_applies(inputs)
	return zh_privacy_section_1_applies(inputs)
};